<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer no-line-height">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Instalment.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Instalment.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.Instalment.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="keypad-wrap installment">
          <div class="keypad keypad--installment keypad--white">
            <button>{{ $t('Modal.Instalment.msg4') }} ></button>
            <button @mouseup="$emit('setSign', '02')" class="btn-anim">2{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '03')" class="btn-anim">3{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '04')" class="btn-anim">4{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '05')" class="btn-anim">5{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '06')" class="btn-anim">6{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '07')" class="btn-anim">7{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '08')" class="btn-anim">8{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '09')" class="btn-anim">9{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '10')" class="btn-anim">10{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '11')" class="btn-anim">11{{ $t('Modal.Instalment.msg5') }}</button>
            <button @mouseup="$emit('setSign', '12')" class="btn-anim">12{{ $t('Modal.Instalment.msg5') }}</button>
          </div>
          <div style="margin-top: 0.4em">
            <button class="btn btn--violet btn--xlg btn-anim btn--shadow" @mouseup="$emit('setSign', '00')">{{ $t('Modal.Instalment.msg6') }}</button>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeInstalment')">{{ $t('Modal.Instalment.msg7') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'instalment',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {},
  methods: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .keypad-wrap.installment {
    width: 47vw !important;
  }
}
.no-line-height {
  line-height: 0.3em;
}

.lyr-txt {
  line-height: 1.6em;
}

.keypad-wrap.installment {
  width: 46vw;
  margin: 0 auto;
}

.keypad.keypad--installment button {
  width: 13.3vw;
  height: 5.2vh;
  margin: 0.4em;
  box-shadow: 0 8px 12px rgba(54, 52, 62, 0.32);
  font-size: 1.2em;
  font-weight: normal;
}
</style>
